import { render, staticRenderFns } from "./AddressSearchSuperNew.vue?vue&type=template&id=3a39e6b7&scoped=true&"
import script from "./AddressSearchSuperNew.vue?vue&type=script&lang=js&"
export * from "./AddressSearchSuperNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39e6b7",
  null
  
)

export default component.exports